/* eslint-disable sort-keys */
import {
    BRAND,
    CLASS,
    COUNTRY,
    NET_VOLUME,
    RAW,
    REGION,
    RICE_AFTER_POLISHING,
    STRONGNESS,
    TEMPERATURE_FROM,
    TEMPERATURE_TO,
} from 'modules/product-card/constants/characteristics';

const HEADER = [COUNTRY, REGION, BRAND, STRONGNESS, NET_VOLUME, CLASS, RICE_AFTER_POLISHING, RAW];
const DETAILED = [REGION, STRONGNESS, TEMPERATURE_FROM, TEMPERATURE_TO];
const TABLET = [...HEADER, ...DETAILED];

export const SAKE_CHARACTERISTICS = {
    HEADER,
    DETAILED,
    TABLET,
};
